// extracted by mini-css-extract-plugin
export default {"overlay":"Modal_overlay__gE0B9","modal":"Modal_modal__YwX8Y","scrollable":"Modal_scrollable__I5-o4","overflowVisible":"Modal_overflowVisible__J10tT"};